<button *ngIf="isFeatureQualityReportEnabled" style="margin-left: 24px;" mat-raised-button color="accent" (click)="showQualityReport()"> Show quality report </button>
<mat-accordion class="mat-elevation-z0">
  <mat-expansion-panel class="mat-elevation-z0" *ngFor="let das of datasources | keyvalue">
    <mat-expansion-panel-header
      >Show {{ das.key }} packs</mat-expansion-panel-header
    >
    <app-table-component [ds]=das.value></app-table-component>
  </mat-expansion-panel>
  <mat-expansion-panel class="mat-elevation-z0" [hidden]="!meta">
    <mat-expansion-panel-header>Show meta files</mat-expansion-panel-header>
    <table mat-table [dataSource]="datasourceMeta" #mSort="matSort" matSort class="mat-elevation-z0"
          matSortActive="type" matSortDisableClear matSortDirection="desc">
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let element">{{ element.type }}</td>
      </ng-container>
      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Filename</th>
        <td mat-cell *matCellDef="let element">{{ element.fileName }}</td>
      </ng-container>
      <tr class="no-padding" mat-header-row *matHeaderRowDef="displayedColumnsMeta"></tr>
      <tr class="no-padding" mat-row *matRowDef="let row; columns: displayedColumnsMeta"></tr>
    </table>
  </mat-expansion-panel>
</mat-accordion>
